import { useCallback } from 'react';

import { useOnError } from '@/scenarios/legacy-player/hooks/useOnError';
import { useOnReady } from '@/scenarios/legacy-player/hooks/useOnReady';
import { usePlayerInstance } from '@/scenarios/legacy-player/lib/contexts/instance';

interface PlayerManagerControllerProps {
    isModalOpen: boolean;
}

export const PlayerManagerController = ({ isModalOpen }: PlayerManagerControllerProps) => {
    const instance = usePlayerInstance();
    const stopPlayer = useCallback(() => {
        if (!isModalOpen && instance) {
            if (instance.type === 'filmoscope') {
                instance.pureInstance.stop();
            } else {
                instance.pureInstance.pause();
            }
        }
    }, [instance, isModalOpen]);

    useOnReady(stopPlayer);
    useOnError(stopPlayer);

    return null;
};
